import React from 'react';
import { SocialIcon } from 'react-social-icons';
import { HashLink } from 'react-router-hash-link';

const MobileNavbar = () => {
	return (
		<div className='lg:hidden'>
			<div className='navlinkgroup'>
				<HashLink
					to='#home'
					className='hashlink
  '
				>
					Home
				</HashLink>

				<HashLink
					to='#about'
					className='hashlink
  '
				>
					About
				</HashLink>

				<HashLink
					to='#project'
					className='hashlink
  '
				>
					Projects
				</HashLink>

				<HashLink
					to='#services'
					className='hashlink
  '
				>
					Services
				</HashLink>
				<HashLink
					to='#contact'
					className='hashlink
  '
				>
					Contact
				</HashLink>
			</div>

			<div className='socialicon'>
				<SocialIcon
					url='https://www.linkedin.com/in/firat-tezcan-ab77a7129/'
					className='mr-4'
					target='_blank'
					fgColor='#fff'
					style={{ height: 35, width: 35 }}
				/>
				<SocialIcon
					url='https://github.com/Firat92'
					className='mr-4'
					target='_blank'
					fgColor='#fff'
					style={{ height: 35, width: 35 }}
				/>
			</div>
		</div>
	);
};

export default MobileNavbar;
